import {Record as record} from 'immutable';

export default record(
    {
        reviewCount: null,
        averageRating: null,
        ownershipTransferred: false,
        reviews: [],
        isFetching: false,
        previewCount: 3,
        reviewId: '',
        scrollTop: false,
        pageIndex: 1,
        prevPageIndex: 1,
        verificationDisclaimerLinkText: null,
        verificationDisclaimerLinkUrl: null,
        verificationDisclaimerText: null
    },
    'ReviewsRecord'
);
